module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKBAMAAABLZROSAAAAFVBMVEWxzfBHcEyxzfCxzfCxzfCxzfCxzfCFBe3hAAAAB3RSTlMwABDP32BAJj1+4gAAAEFJREFUCNdjEAQCJhDBAMQCzopQFgurEYQl4CAYrAhmsTAKihqBWEAhQZAgA0hIECTIABYCCTKAhUCCDAqCEJAIAIHiCCx/IlkiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/up.png
// module id = g0Ew
// module chunks = 37